import React from 'react'
import { useIntl } from 'react-intl'

//TODO: Implement the EmployeePortal view
const EmployeePortal = () => {
  const intl = useIntl()

  return (
    <div className="text__container ">
      {intl.formatMessage({ id: 'viewState.todo' })}
    </div>
  )
}

export default EmployeePortal
